import type {
  SelectedLegIdByStepIndexChangedAction,
  SelectedLegIdByStepIndexRemovedAction,
} from '@web-platform/shared-universal-types/src/redux/actions/actions-shared-types';

export const SELECTED_LEG_ID_BY_STEP_INDEX_CHANGED = 'SELECTED_LEG_ID_BY_STEP_INDEX_CHANGED';
export const SELECTED_LEG_ID_BY_STEP_INDEX_REMOVED = 'SELECTED_LEG_ID_BY_STEP_INDEX_REMOVED';
export const SHOW_STEP_SELECTION_LOADING_CHANGED = 'SHOW_STEP_SELECTION_LOADING_CHANGED';
export const SELECTED_LEG_ID_BY_STEP_INDEX_RESET = 'SELECTED_LEG_ID_BY_STEP_INDEX_RESET';

export const selectedLegIdByStepIndexChanged = (
  stepIndex: number,
  legId: string,
): SelectedLegIdByStepIndexChangedAction => ({
  type: SELECTED_LEG_ID_BY_STEP_INDEX_CHANGED,
  payload: {
    stepIndex,
    legId,
  },
});

export const selectedLegIdByStepIndexRemoved = (
  stepIndex: number,
): SelectedLegIdByStepIndexRemovedAction => ({
  type: SELECTED_LEG_ID_BY_STEP_INDEX_REMOVED,
  payload: {
    stepIndex,
  },
});

export const showStepSelectionLoadingChanged = (show: boolean) => ({
  type: SHOW_STEP_SELECTION_LOADING_CHANGED,
  payload: show,
});

export const selectedLegIdByStepIndexReset = () => ({
  type: SELECTED_LEG_ID_BY_STEP_INDEX_RESET,
});
